import { lazy, Suspense } from "react";
import Loading from "../../pages/loading";
const ExpenseMainPage = lazy(() =>
  import("../../components/expense/ExpenseMainPage")
);

const Index = () => {
  return (
    <Suspense fallback={<Loading />}>
      <ExpenseMainPage />
    </Suspense>
  );
};

export default Index;
